/**
 * @deprecated Use `useThread(t => t.messages.length === 0)` instead. This will be removed in 0.6.
 */
export { useThreadEmpty } from "./useThreadEmpty";
/**
 * @deprecated Use `useThread(m => <condition>)` instead. This will be removed in 0.6.
 */
export { useThreadIf } from "./useThreadIf";
/**
 * @deprecated Use `useThreadViewport().scrollToBottom()` instead. This will be removed in 0.6.
 */
export { useThreadScrollToBottom } from "./useThreadScrollToBottom";
/**
 * @deprecated Use `useThreadRuntime().append()` instead. This will be removed in 0.6.
 */
export { useThreadSuggestion } from "./useThreadSuggestion";
